import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'L.A. Jackson richt de London Rubber Company op en verkoopt geïmporteerde condooms en kappersbenodigdheden',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) deponeert het merk Durex',
		},
		{
			year: '1950er',
			description: 'Durex brengt zijn eerste condoom met glijmiddel op de markt',
		},
		{
			year: 1953,
			description: 'Durex is het eerste merk dat elektronische tests ontwikkelt en uitvoert',
		},
		{
			year: '1960er',
			description: 'Durex lanceert het eerste anatomisch gevormde condoom',
		},
		{
			year: '1970er',
			description: 'Durex is het eerste condoommerk ter wereld dat in tal van landen reclame maakt',
		},
		{
			year: '1990er',
			description: 'Durex is het eerste condoommerk dat een internationaal kwaliteitslabel als norm hanteer',
		},
		{
			year: 1995,
			description: 'Durex lanceert een gamma van gekleurde condooms met een smaakje',
		},
		{
			year: 1996,
			description: 'Durex is het eerste condoommerk dat een website lanceert. Vandaag de dag hebben we 42 verschillende sites in de landen waar het merk wordt verkocht',
		},
		{
			year: 1997,
			description: 'Durex brengt latexvrije condooms op de markt. Voor het nieuwe product wordt een nieuw anti-allergeen materiaal gebruikt: synthetisch polyurethaan. Het werd ontwikkeld door Durex en is zachter en elastischer dan het natuurrubber van latex',
		},
		{
			year: 1998,
			description: 'Durex is het eerste condoommerk dat een wereldwijd onderzoek over seksueel welzijn uitvoert en publiceert',
		},
		{
			year: 2001,
			description: 'Durex stelt Pleasuremax voor. Dit maakt van Durex het eerste merk dat een condoom met ribbels en nopjes verkoopt',
		},
		{
			year: 2003,
			description: 'Durex lanceert Play, een aanbod met comfortabele en speelse glijmiddelen',
		},
		{
			year: 2005,
			description: 'Het Durex-netwerk lanceert zijn ‘Face of Global Sex’-studie waarin seksuele gewoonten worden onderzocht met de bedoeling om academici en overheden te informeren',
		},
		{
			year: 2008,
			description: 'Om veilig vrijen onder jongeren te bevorderen, moedigt Durex jongeren tussen 16 en 24 jaar aan om een unieke poster over seksuele gezondheid te maken - een poster voor tieners door tieners',
		},
		{
			year: 2009,
			description: 'Durex wordt 80!',
		},
		{
			year: 2010,
			description: 'Durex ondersteunt het ‘Condomize!’-initiatief van het Bevolkingsfonds van de Verenigde Naties tijdens de Internationale Aids-conferentie in Wenen door 220.000 condooms te doneren',
		},
		{
			year: 2010,
			description: 'Durex wordt overgenomen door Reckitt Benckiser',
		},
		{
			year: 2010,
			description: 'Durex lanceert Performax Intense, een condoom dat ontworpen is om tegelijk een orgasme te bereiken. De 5% benzocaïne aan de binnenkant en een stimulerende structuur aan de buitenkant helpt het om langer en intenser te vrijen',
		},
		{
			year: 2018,
			description: 'Samenwerking met RED',
		},
		{
			year: 2019,
			description: 'Durex wordt 90!',
		},
		{
			year: 2020,
			description: 'Lancering in apotheken en supermarkten van Perfect Gliss, een assortiment van condooms en glijmiddelen speciaal voor anale seks',
		},
		{
			year: 2020,
			description: 'Verduidelijking op de Durex-condoomdoosjes door een visuele codering toe te voegen om de consument het condoom te helpen kiezen dat het beste bij hem past: maat, nominale breedte, glijmiddel en materiaal',
		},
	]
}